import { IClientCityBrief } from '@bustickus/models-client';

function getCityByName(cities: IClientCityBrief[], cityName: string): IClientCityBrief | null {
  for (const city of cities) {
    if (city.name.toLowerCase().trim().includes(cityName.toLowerCase().trim())) {
      return city;
    }
  }

  return null;
}

export default getCityByName;
